import { dataTwoHeartsSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTwoHeartsSolid = /*#__PURE__*/createIcon(dataTwoHeartsSolid)
export default IconTwoHeartsSolid
